import CustomText from "../atomic/CustomText";
import DetailRenderer from "../global/forms/DetailRenderer";

const PatientInformation = ({ order }: any) => (
  <div id="patient info">
    <CustomText
      text="Patient Information"
      fontWeight="font-medium"
      className="reviewCardHeading my-5"
    />
    <div className="reviewCard">
      <DetailRenderer
        data={order.patientInfo}
        groupFields={[
          "firstName",
          "middleInitial",
          "lastName",
          "dateOfBirth",
          "sexAtBirth",
        ]}
        hiddenFields={[]}
        MainHeading="Patient Information"
        // approval={true}
      />
      {order?.testType?.test === 4 && (
        <DetailRenderer
          data={order.patientSecurity}
          groupFields={["ssn", "mrn"]}
          hiddenFields={[]}
          MainHeading="Additional Patient Identifier (Optional)"
          // approval={true}
        />
      )}
      <DetailRenderer
        data={order.patientContact}
        groupFields={["email", "address", "city", "state", "phone", "zipcode"]}
        hiddenFields={[]}
        MainHeading="Patient Contact Information"
      />
    </div>
  </div>
);

export default PatientInformation;